"use strict";
export const Validate = {

	validate: function() {
		var $this 		= $(this),
			formItem 	= $this.closest('.form-item'),
			messageDiv 	= $this.closest('.form').find('.form-message'),
			errMessage 	= messageDiv.data('error-message');

		$this.parsley({
			listeners: {
				onFieldSuccess: function (elem, ParsleyField) {
					var errors = $('.parsley-error');

					if (errors.length === 0) {
						messageDiv.removeClass('error').hide().empty();
					}
				},
				onFieldError: function(elem, constraints, ParsleyField) {
					if (messageDiv.is(':empty')) {
						messageDiv.addClass('error alert-error').append("<h4 style=\"color:#d0103a;margin:0;\">" + errMessage + "</h4>").show();
					}
				}
			}
		});
		if ($this.parsley('validate') === null) {
			return true;
		} else {
			return $this.parsley('validate');
		}
	},
	reset: function () {
	    var $this = $(this),
            $formItems = $('.form-item input, .form-item textarea', $this),
            $messageDiv = $('.form-message', $this);
	    $formItems.each(function () { $(this).parsley('reset'); });
	    $messageDiv.removeClass('error').hide().empty();
	}
};